"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  question: "What is a clarity call and who is it for?",
  answer: "Our free clarity call is the first step in our value ladder, designed for creative entrepreneurs and freelancers looking to identify their biggest growth bottlenecks and see if our strategic consulting is the right fit for their vision."
}, {
  question: "How do your VIP programs work?",
  answer: "Our elite VIP programs are intensive, high-touch engagements tailored for established businesses ready to scale. We provide comprehensive support from ideation to execution, integrating your creative vision with proven strategic frameworks to ensure measurable results."
}, {
  question: "Do you offer customized creative strategies?",
  answer: "Absolutely. We believe in a holistic approach. We don't use cookie-cutter templates; instead, we develop customized creative strategies tailored specifically to your brand's unique voice, target audience, and long-term goals."
}, {
  question: "What kind of results can I expect?",
  answer: "While individual results vary based on implementation, our clients typically see significant improvements in brand engagement and business scaling. For example, our strategies have helped creative professionals double their engagement in just three months and secure high-profile clients."
}, {
  question: "How do I know which tier of your value ladder is right for me?",
  answer: "We recommend starting with our free assessment or clarity call. During this initial phase, we'll evaluate your current business stage, discuss your goals, and recommend the most effective path forward—whether that's a self-paced content guide or a full VIP coaching session."
}];
export default function CommonQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="common-questions" className="py-24 md:py-32 bg-background text-foreground overflow-hidden">
      <div ref={ref} className={`container mx-auto px-4 max-w-[800px] transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-center mb-12 text-foreground tracking-tight">
          Navigating Your Growth
        </h2>

        <Accordion type="single" collapsible className="w-full space-y-6">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border border-border/40 px-6 py-2 transition-all duration-300 data-[state=open]:bg-card data-[state=open]:shadow-md data-[state=open]:border-border/80 rounded-xl">
              <AccordionTrigger className="text-base md:text-lg font-sans font-semibold hover:no-underline hover:text-primary transition-colors text-left">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground font-sans text-base leading-relaxed pb-6 pt-2 pr-8">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}